module.exports = window['kestrel-components'];